import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    billing: null,
    communicationRule: null,
    nfse: null,
};
const billingProductsSlice = createSlice({
    name: 'billingProducts',
    initialState,
    reducers: {
        setBillingProduct: (state, action) => {
            state.billing = action.payload;
        },
        setCommunicationRuleProduct: (state, action) => {
            state.communicationRule = action.payload;
        },
        setNfseProduct: (state, action) => {
            state.nfse = action.payload;
        },
        setBillingProducts: (state, action) => {
            state.billing = action.payload.billing;
            state.communicationRule = action.payload.communicationRule;
            state.nfse = action.payload.nfse;
        },
        clearBillingProducts: () => initialState,
    },
});
export const { setBillingProduct, setCommunicationRuleProduct, setNfseProduct, setBillingProducts, clearBillingProducts, } = billingProductsSlice.actions;
export default billingProductsSlice.reducer;
